import { Loader } from "@src/global_components";
import { AppRoute } from "@src/global_components/AppRoute";
import { lazy, Suspense } from "react";
import { Redirect, Switch } from "react-router-dom";

const ProfileSettings = lazy(
  () => import("../ProfileSettings/ProfileSettings")
);
const UserManagement = lazy(() => import("../UserManagement"));
const Accounts = lazy(() => import("../Accounts/Accounts"));

export function SettingsRouter() {
  return (
    <div>
      <Suspense fallback={<Loader />}>
        <Switch>
          <AppRoute
            path="/settings/profile"
            render={() => <ProfileSettings />}
          />
          <AppRoute path="/settings/users" render={() => <UserManagement />} />
          <AppRoute path="/settings/accounts" render={() => <Accounts />} />
          <Redirect path="/settings" to="/settings/profile" />
        </Switch>
      </Suspense>
    </div>
  );
}
